module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ja-企业文化核心内容.846754aa.png";